import { Tag } from "./styles";

const StandOut = () => {
  return <Tag id="standoutDivAutomatico" />;
};

export default StandOut;
